import { CreditCard } from "lucide-react"

interface PaymentButtonsProps {
  applePayAvailable: boolean
  onApplePay: () => void
  onCard: () => void
}

/** Primary checkout CTAs: "Buy with  Pay" (light surface) and "Credit or debit card" (gradient). */
export function PaymentButtons({ applePayAvailable, onApplePay, onCard }: PaymentButtonsProps) {
  return (
    <div className="space-y-3">
      {applePayAvailable && (
        <button
          type="button"
          onClick={onApplePay}
          className="flex h-14 w-full items-center justify-center gap-2 rounded-full bg-purple-light text-dark-base transition-opacity hover:opacity-90"
        >
          <span className="text-base font-semibold">Buy with</span>
          <span className="flex items-center gap-1">
            <svg viewBox="0 0 24 24" className="size-6 fill-current" aria-hidden>
              <path d="M17.05 12.18c0-2.06 1.69-3.05 1.77-3.1-0.97-1.42-2.49-1.61-3.03-1.64-1.29-0.13-2.51 0.76-3.16 0.76-0.66 0-1.66-0.74-2.74-0.72-1.41 0.02-2.71 0.82-3.43 2.08-1.46 2.54-0.37 6.29 1.05 8.36 0.7 1.02 1.53 2.16 2.61 2.12 1.05-0.04 1.45-0.68 2.72-0.68 1.27 0 1.62 0.68 2.73 0.66 1.13-0.02 1.84-1.02 2.53-2.05 0.8-1.18 1.13-2.32 1.15-2.38-0.03-0.01-2.21-0.85-2.23-3.36zM15.06 6.42c0.57-0.69 0.96-1.65 0.85-2.61-0.83 0.04-1.83 0.55-2.42 1.24-0.53 0.61-0.99 1.59-0.87 2.53 0.92 0.07 1.87-0.47 2.44-1.16z" />
            </svg>
            <span className="text-xl font-semibold">Pay</span>
          </span>
        </button>
      )}
      <button
        type="button"
        onClick={onCard}
        className="flex h-14 w-full items-center justify-center gap-2 rounded-full bg-gradient-to-b from-peach to-purple-accent text-lg font-semibold text-white transition-opacity hover:opacity-90"
      >
        <CreditCard className="size-5" />
        Credit or debit card
      </button>
    </div>
  )
}
